Vue.component("subscribe", {

    mixins: [require("../../../mixins/address.js")],

    props: ["subscriptionTeam", "pricing", "pendingDebitOrder"],

    data () {
        return {
            team: this.subscriptionTeam,
            form: new AppForm({}),

            // After an upgrade request we create a dummy debit in order to prevent the user from requesting another upgrade
            hasPendingDebitOrder : this.pendingDebitOrder,
            debitOrderToken: this.subscriptionTeam.subscription.debit_order_token,

            banks: [
                {value: "First National Bank", branchCode: "250655"},
                {value: "Nedbank", branchCode: "198765"},
                {value: "ABSA", branchCode: "632005"},
                {value: "Standard Bank", branchCode: "051001"},
                {value: "Capitec", branchCode: "470010"},
                {value: "Investec", branchCode: "580105"},
                {value: "RMB", branchCode: "254005"},
                {value: "African Bank", branchCode: "430000"},
                {value: "Post Bank", branchCode: "460005"},
                {value: "Bidvest Bank", branchCode: "462005"}
            ],
            accountTypes: ["Current", "Saving"],
            monthlyLicense: this.pricing.monthly_license_fee,
            additionalUsersAmount: this.pricing.monthly_additional_user_fee,
            includedUsers: this.pricing.included_users,
            annualPlanDiscount: this.pricing.annual_plan_discount_percentage,
            vat: this.pricing.vat
        };
    },

    mounted () {
        this.form = new AppForm({
            pricing_plan: this.subscriptionTeam.subscription.pricing_plan || "premium_plus",
            payment_plan: "monthly",
            data_option: this.subscriptionTeam.subscription.data_option || "manual",
            number_of_users: this.subscriptionTeam.subscription.subscription_users || 5,
            invoice_recipients: this.subscriptionTeam.subscription.invoice_recipients || this.app.state.user.email,
            account_name: this.subscriptionTeam.billing_detail.account_name,
            bank: this.subscriptionTeam.billing_detail.bank,
            branch_code: this.subscriptionTeam.billing_detail.branch_code,
            account_number: this.subscriptionTeam.billing_detail.account_number,
            account_type: this.subscriptionTeam.billing_detail.account_type,
            vat_id: this.subscriptionTeam.vat_id
        });
    },

    watch: {
        "form.bank": function (selectedBank) {
            let index = this.banks.findIndex(bank => bank.value === selectedBank);
            if (index !== -1) {
                this.form.branch_code = this.banks[index].branchCode;
            }
        },

        "form.account_number": function (newVal) {
            if (newVal) {
                this.form.account_number = newVal.replace(/\D/g, "").trim();
            }
        },
    },

    computed: {

        premiumPlanSelected () {
            return this.form.pricing_plan === "premium_plus";
        },

        limitedPlanSelected () {
            return this.form.pricing_plan === "limited";
        },

        isAnnual () {
            return this.form.payment_plan === "annual";
        },

        formattedEscalationDate () {
            return moment(this.pricing.escalation_date, "DD-MM").format("DD MMMM");
        },

        /**
         * Billing address for the team
         */
        address () {
            return this.team.billing_detail.address;
        },

        billingAddressLabel () {
            return _.isEmpty(this.team.billing_detail.address.full_address) ? "No address" : this.team.billing_detail.address.full_address;
        },

        /**
         * Returns array with line items for annual invoice
         */
        annualInvoice () {

            let invoice = [];

            let annualLicense = this.monthlyLicense * 12;
            invoice.push({
                description: "Annual License Fee - R" + this.pricing.plans.premium_plus.monthly_license_fee + " p/m (5 users)",
                symbol: "R",
                amount: annualLicense
            });

            if (this.form.number_of_users > this.includedUsers) {

                let additionalUsers = this.form.number_of_users - this.includedUsers;
                let additionalUsersTotalAmount = additionalUsers * this.additionalUsersAmount * 12;

                let additionalUsersDescription = additionalUsers > 1 ?
                    additionalUsers + " x extra users" :
                    additionalUsers + " x extra user";

                invoice.push({
                    description: additionalUsersDescription,
                    symbol: "R",
                    amount: additionalUsersTotalAmount
                });

            }

            return invoice;

        },

        /**
         * Returns array with line items for monthly debit order
         */
        monthlyInvoice () {

            let monthlyInvoice = [];

            if (this.form.pricing_plan === "limited") {
                monthlyInvoice.push({
                    description: "Monthly License Fee (Single User)",
                    symbol: "R",
                    amount: this.pricing.plans.limited.monthly_license_fee
                });
            } else {
                monthlyInvoice.push({
                    description: "Monthly License Fee (5 users)",
                    symbol: "R",
                    amount: this.pricing.plans.premium_plus.monthly_license_fee
                });

                if (this.form.number_of_users > this.includedUsers) {
                    let additionalUsers = this.form.number_of_users - this.includedUsers;
                    let additionalUsersTotalAmount = additionalUsers * this.additionalUsersAmount;
                    let additionalUsersDescription = additionalUsers > 1 ?
                        additionalUsers + " x extra users @ R" + this.additionalUsersAmount + " per user" :
                        additionalUsers + " x extra user @ R" + this.additionalUsersAmount;

                    monthlyInvoice.push({
                        description: additionalUsersDescription,
                        symbol: "R",
                        amount: additionalUsersTotalAmount
                    });
                }
            }
            return monthlyInvoice;
        },
    },

    methods: {

        dynamicClass (plan){
            return this.form.pricing_plan === plan ? 'bg-dark text-white' : 'bg-white text-dark';
        },

        getFormattedSubscriptionPlanName () {
            switch (this.subscriptionTeam.subscription.pricing_plan) {
                case "premium":
                    return "Premium Plan";
                case "limited":
                    return "Limited Plan";
                default:
                    return "PremiumPlus Plan";
            }
        },

        changePricingPlan (plan) {
            this.form.pricing_plan = plan;
            if (this.form.pricing_plan === "limited") {
                this.form.number_of_users = 1;
                this.form.payment_plan = "monthly";
            }
        },

        calculateInvoiceTotal (invoice) {
            return _.sumBy(invoice, function (i) {
                return i.amount;
            });
        },

        calculateInvoiceVat (invoice) {
            return this.calculateInvoiceTotal(invoice) * this.vat;
        },

        subscribe () {
            // Check if billing address is provided
            if (_.isEmpty(this.team.billing_detail.address.full_address)) {
                this.showAddressRequiredMessage();
                this.editAddress(this.address.id);
                return;
            }

            App.patch("/settings/billing/subscription/" + this.team.subscription.id + "/subscribe", this.form)
            .then(response => {
                this.team.subscription = response;
            })
            .catch(errors => {
                toastr.error("Error saving subscription!");
            });

        },

        showAddressRequiredMessage () {
            this.form.setErrors({address: ["Billing address is required."]});
            toastr.error("Complete your billing address to subscribe!");
        },

        handleAddressUpdatedCallback (address) {
            this.form.errors.forget();
            this.team.billing_detail.address = address;
        },

        bankSearch (queryString, cb) {
            let banks = this.banks;
            let results = queryString ? banks.filter(this.createBankFilter(queryString)) : banks;
            // call callback function to return suggestions
            cb(results);
        },

        createBankFilter (queryString) {
            return (bank) => {
                return (bank.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },

        requestSubscriptionUpgrade () {
            App.post("/settings/billing/subscription/" + this.team.subscription.id + "/request-upgrade", new AppForm({}))
            .then((response) => {
                toastr.success(response);
                this.hasPendingDebitOrder = true;
            }).catch(() => {
                toastr.error("Could not process upgrade request. Please contact support");
            });
        }
    }
});


